<template>
  <div>
    <div class="my-5">รูปแบบธีม</div>
    <v-expansion-panels accordion multiple>
      <v-expansion-panel>
        <v-expansion-panel-header> พื้นหลัง </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card flat>
            <v-card-text class="pa-0"> สีพื้นหลัง </v-card-text>
            <v-card-text class="pa-0">
              <v-color-picker
                v-model="endform_theme.bg_color"
                class="my-6"
              ></v-color-picker>
            </v-card-text>
            <v-card-text class="pa-0"> รูปภาพพื้นหลัง </v-card-text>
            <v-card-text class="px-0">
              <v-card v-show="!endform_theme.bg_image" class="pl-2" flat>
                <input
                  ref="bgimage"
                  type="file"
                  accept="image/*"
                  @change="BGImage()"
                  class="d-none"
                />
                <v-btn @click="$refs.bgimage.click()">
                  <v-icon small class="mr-2">mdi-image</v-icon>
                  เลือกรูปภาพ
                </v-btn>
              </v-card>
              <v-card v-show="endform_theme.bg_image" class="pl-2" flat>
                <v-card>
                  <v-card-title class="pa-1">
                    <v-spacer></v-spacer>
                    <v-btn
                      icon
                      color="#DE4F3B"
                      @click="endform_theme.bg_image = false"
                      ><v-icon>clear</v-icon></v-btn
                    >
                  </v-card-title>
                  <v-card-text class="d-flex justify-center">
                    <img :src="endform_theme.bg_image_url" width="100" />
                  </v-card-text>
                  <v-card-text>
                    <v-btn
                      color="primary"
                      outlined
                      block
                      @click="$refs.bgimage.click()"
                      >เปลี่ยนรูป</v-btn
                    >
                  </v-card-text>
                  <v-card-text>
                    <v-radio-group
                      v-model="endform_theme.bg_repeat"
                      hide-details=""
                    >
                      <template v-slot:label> ปรับรูปภาพพื้นหลัง </template>
                      <v-radio value="repeat">
                        <template v-slot:label>
                          <div>รูปภาพซ้ำปกติ</div>
                        </template>
                      </v-radio>
                      <v-radio value="repeat-x">
                        <template v-slot:label>
                          <div>รูปภาพซ้ำไปทางแนวนอน</div>
                        </template>
                      </v-radio>
                      <v-radio value="repeat-y">
                        <template v-slot:label>
                          <div>รูปภาพซ้ำไปทางแนวตั้ง</div>
                        </template>
                      </v-radio>
                      <v-radio value="no-repeat">
                        <template v-slot:label>
                          <div>รูปภาพไม่ซ้ำ</div>
                        </template>
                      </v-radio>
                      <v-radio value="space">
                        <template v-slot:label>
                          <div>รูปภาพซ้ำแบบมีช่องว่าง</div>
                        </template>
                      </v-radio>
                      <v-radio value="round">
                        <template v-slot:label>
                          <div>รูปภาพซ้ำแบบพอดีหน้าจอ</div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                    <v-radio-group
                      v-model="endform_theme.bg_size"
                      hide-details=""
                    >
                      <template v-slot:label> รูปแบบภาพพื้นหลัง </template>
                      <v-radio value="auto">
                        <template v-slot:label>
                          <div>อัตโนมัติ</div>
                        </template>
                      </v-radio>
                      <v-radio value="100% 100%">
                        <template v-slot:label>
                          <div>พอดีหน้าจอ</div>
                        </template>
                      </v-radio>
                      <v-radio value="cover">
                        <template v-slot:label>
                          <div>เต็มจอตามความยาวรูปภาพ</div>
                        </template>
                      </v-radio>
                      <v-radio value="contain">
                        <template v-slot:label>
                          <div>เต็มจอตามความสูงรูปภาพ</div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                    <v-radio-group
                      v-model="endform_theme.bg_position_x"
                      hide-details=""
                    >
                      <template v-slot:label>
                        การจัดวางตามแกน x (แนวนอน)
                      </template>
                      <v-radio value="left">
                        <template v-slot:label>
                          <div>ซ้าย</div>
                        </template>
                      </v-radio>
                      <v-radio value="center">
                        <template v-slot:label>
                          <div>กลาง</div>
                        </template>
                      </v-radio>
                      <v-radio value="right">
                        <template v-slot:label>
                          <div>ขวา</div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                    <v-radio-group
                      v-model="endform_theme.bg_position_y"
                      hide-details=""
                    >
                      <template v-slot:label>
                        การจัดวางตามแกน y (แนวตั้ง)
                      </template>
                      <v-radio value="top">
                        <template v-slot:label>
                          <div>บน</div>
                        </template>
                      </v-radio>
                      <v-radio value="center">
                        <template v-slot:label>
                          <div>กลาง</div>
                        </template>
                      </v-radio>
                      <v-radio value="bottom">
                        <template v-slot:label>
                          <div>ล่าง</div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-card-text>
                </v-card>
              </v-card>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          ข้อความจบแบบสอบถาม
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card flat>
            <v-card-text class="pa-0"> สีข้อความ </v-card-text>
            <v-card-text class="pa-0">
              <v-color-picker
                v-model="endform_theme.text_color"
                class="my-6"
              ></v-color-picker>
            </v-card-text>
            <v-row no-gutters align="center">
              <v-col cols="4">ขนาดข้อความ : </v-col>
              <v-col cols="5">
                <v-text-field
                  v-model="endform_theme.text_size"
                  type="number"
                  dense
                  min="1"
                  class="mx-3"
                  suffix="px"
                >
                </v-text-field
              ></v-col>
            </v-row>
            <v-card-text class="pa-0">
              <v-radio-group
                v-model="endform_theme.text_justify"
                hide-details=""
              >
                <template v-slot:label> การจัดว่าง </template>
                <v-radio value="start">
                  <template v-slot:label>
                    <div>ชิดซ้าย</div>
                  </template>
                </v-radio>
                <v-radio value="center">
                  <template v-slot:label>
                    <div>ตรงกลาง</div>
                  </template>
                </v-radio>
                <v-radio value="end">
                  <template v-slot:label>
                    <div>ชิดขวา</div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header> รูปภาพจบแบบสอบถาม </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card flat>
            <v-card-text class="pa-0"> รูปภาพจบแบบสอบถาม </v-card-text>
            <v-card-text class="px-0">
              <v-card v-show="!endform_theme.image" class="pl-2" flat>
                <input
                  ref="endimage"
                  type="file"
                  accept="image/*"
                  @change="EndImage()"
                  class="d-none"
                />
                <v-btn @click="$refs.endimage.click()">
                  <v-icon small class="mr-2">mdi-image</v-icon>
                  เลือกรูปภาพ
                </v-btn>
              </v-card>
              <v-card v-show="endform_theme.image" class="pl-2" flat>
                <v-card>
                  <v-card-title class="pa-1">
                    <v-spacer></v-spacer>
                    <v-btn
                      icon
                      color="#DE4F3B"
                      @click="endform_theme.image = false"
                      ><v-icon>clear</v-icon></v-btn
                    >
                  </v-card-title>
                  <v-card-text class="d-flex justify-center">
                    <img :src="endform_theme.image_url" width="100" />
                  </v-card-text>
                  <v-card-text>
                    <v-btn
                      color="primary"
                      outlined
                      block
                      @click="$refs.endimage.click()"
                      >เปลี่ยนรูป</v-btn
                    >
                  </v-card-text>
                  <v-card-text>
                    <v-row no-gutters align="center">
                      <v-col cols="3">ขนาด : </v-col>
                      <v-col cols="9">
                        <v-slider
                          v-model="ImageSize"
                          min="1"
                          max="100"
                          step="1"
                          hide-details=""
                        >
                          <template #append>
                            <v-btn @click="HZoomIn" icon
                              ><v-icon>mdi-magnify-plus-outline</v-icon></v-btn
                            >
                          </template>
                          <template #prepend>
                            <v-btn @click="HZoomOut" icon>
                              <v-icon>mdi-magnify-minus-outline</v-icon></v-btn
                            >
                          </template>
                        </v-slider>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-card>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          ปุ่มทำแบบสอบถามอีกครั้ง
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card flat>
            <v-card-text class="px-0"> ข้อความ </v-card-text>
            <v-card-text class="pa-0">
              <v-text-field
                v-model="endform_theme.button.text"
                outlined
                dense
                maxlength="30"
                counter="30"
              ></v-text-field>
            </v-card-text>
            <v-card-text class="pa-0">
              <v-radio-group
                v-model="endform_theme.button.bt_texttype"
                hide-details=""
                @change="AgainButtonUI"
              >
                <template v-slot:label> รูปแบบปุ่ม </template>
                <v-radio value="button">
                  <template v-slot:label>
                    <div>แบบที่ 1</div>
                  </template>
                </v-radio>
                <v-radio value="text">
                  <template v-slot:label>
                    <div>แบบที่ 2</div>
                  </template>
                </v-radio>
                <v-radio value="outlined">
                  <template v-slot:label>
                    <div>แบบที่ 3</div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-card-text>
            <v-card-text class="pa-0">
              <v-checkbox
                v-model="endform_theme.button.bt_block"
                label="ปุ่มยาวเต็มกรอบ"
                hide-details=""
              ></v-checkbox>
            </v-card-text>
            <v-card-text class="px-0">
              <v-checkbox
                v-model="endform_theme.button.bt_rounded"
                label="ขอบมน"
                hide-details=""
              ></v-checkbox>
            </v-card-text>
            <v-card-text
              v-show="endform_theme.button.bt_texttype === 'button'"
              class="pa-0"
            >
              สีพื้นหลังปุ่ม
            </v-card-text>
            <v-card-text
              v-show="endform_theme.button.bt_texttype === 'button'"
              class="pa-0"
            >
              <v-color-picker
                v-model="endform_theme.button.bg_color"
                class="my-6"
              ></v-color-picker>
            </v-card-text>
            <v-card-text class="pa-0">
              สีข้อความ / สีเส้นขอบของปุ่ม
            </v-card-text>
            <v-card-text class="pa-0">
              <v-color-picker
                v-model="endform_theme.button.text_color"
                class="my-6"
              ></v-color-picker>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  props: ["endform_theme"],
  data() {
    return {
      image_size: 100,
    };
  },
  mounted() {
    console.log(this.endform_theme.image_size);
    this.image_size = Math.floor((this.endform_theme.image_size / 400) * 100);
  },
  computed: {
    ImageSize: {
      set: function (val) {
        console.log(val);
        this.image_size = val;
        this.endform_theme.image_size = (val / 100) * 400;
      },
      get: function () {
        console.log("get image_size");
        return this.image_size;
      },
    },
  },
  methods: {
    HZoomOut() {
      this.ImageSize = --this.image_size;
    },
    HZoomIn() {
      this.ImageSize = ++this.image_size;
    },
    BGImage() {
      for (const key in this.$refs.bgimage.files) {
        if (Object.hasOwnProperty.call(this.$refs.bgimage.files, key)) {
          const element = this.$refs.bgimage.files[key];
          if (/\.(jpe?g|png|gif|svg)$/i.test(element.name)) {
            let vm = this;
            let formData = new FormData();
            formData.append("fileMax", 3);
            formData.append("fileData", element);
            formData.append(
              "filePath",
              `survey/${vm.$route.params.surveyID}-bgimage/question-end/`
            );
            formData.append("fileName", `${Date.now()}-logo-`);
            vm.$store.dispatch("UploadFormData", formData).then((req) => {
              vm.endform_theme.bg_image = true;
              vm.endform_theme.bg_image_url = req.data
                .replace(/ /g, "%20")
                .replace(/\(/g, "%28")
                .replace(/\)/g, "%29");
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "กรุณา upload แต่รูปภาพเท่านั้น",
              text: "รองรับ jpg, jpeg, png, gif, svg ",
            }).then(() => {
              this.$refs.bgimage.type = "text";
              this.$refs.bgimage.type = "file";
            });
          }
        }
      }

      this.$refs.bgimage.type = "text";
      this.$refs.bgimage.type = "file";
    },
    EndImage() {
      for (const key in this.$refs.endimage.files) {
        if (Object.hasOwnProperty.call(this.$refs.endimage.files, key)) {
          const element = this.$refs.endimage.files[key];
          if (/\.(jpe?g|png|gif|svg)$/i.test(element.name)) {
            let vm = this;
            let formData = new FormData();
            formData.append("fileMax", 3);
            formData.append("fileData", element);
            formData.append(
              "filePath",
              `survey/${vm.$route.params.surveyID}-image/question-end/`
            );
            formData.append("fileName", `${Date.now()}-logo-`);
            vm.$store.dispatch("UploadFormData", formData).then((req) => {
              vm.endform_theme.image = true;
              vm.endform_theme.image_url = req.data;
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "กรุณา upload แต่รูปภาพเท่านั้น",
              text: "รองรับ jpg, jpeg, png, gif, svg ",
            }).then(() => {
              this.$refs.endimage.type = "text";
              this.$refs.endimage.type = "file";
            });
          }
        }
      }
      this.$refs.endimage.type = "text";
      this.$refs.endimage.type = "file";
    },
    AgainButtonUI() {
      let bg_color = this.endform_theme.bg_color;
      let button_bg_color = this.endform_theme.button.bg_color;
      let button_text_color = this.endform_theme.button.text_color;
      if (
        this.endform_theme.button.bt_texttype === "text" ||
        this.endform_theme.button.bt_texttype === "outlined"
      ) {
        if (
          (bg_color === button_text_color &&
            button_bg_color !== button_text_color) ||
          bg_color === "#FBFBFBFF"
        ) {
          this.endform_theme.button.text_color = button_bg_color;
        }
      } else {
        if (this.endform_theme.button.text_color === button_bg_color) {
          this.endform_theme.button.text_color = bg_color;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
